"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Result, {
    status: "success",
    title: "Successfully Purchased Cloud Server ECS!",
    subTitle: "Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait.",
    extra: [/*#__PURE__*/_react.default.createElement(_antd.Button, {
      type: "primary",
      key: "console"
    }, "Go Console"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "buy"
    }, "Buy Again")]
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorSuccess'],
  key: 'result'
};
var _default = exports.default = componentDemo;